'use strict';

angular.module('mobile-apps')
	.directive('screenshotCreationDate',['$filter', function($filter) {
		return {
			restrict: 'E',
			scope:
			{
				data : '=',
				format: '@'
			},
			link: function(scope, element, attrs) {

				function updateDate() {
					var creationData;

					if (scope.data.hasOwnProperty('metaData') && scope.data.metaData && scope.data.metaData.hasOwnProperty('updatedAt')) {
						// Get date from metadata
						creationData = new Date( scope.data.metaData.updatedAt );
					} else {
						// Get the created date from mongo id
						var timestamp = scope.data._id.toString().substring(0,8);
						creationData = new Date( parseInt( timestamp, 16 ) * 1000 );
					}

					var dateString = '';
					if (creationData !== undefined) {
						if (scope.format === 'long') {
							dateString = $filter('date')(creationData, 'MMMM d, y, h:mm:ss a');
						} else {
							dateString = creationData.toLocaleDateString();
						}
					}

					element.html(dateString);
				}

				scope.$watch(function() {return scope.data && scope.data.metaData && scope.data.metaData.updatedAt; }, function() {
					if (scope.data) {
						updateDate();
					}
				});

			}
		};
	}]);
